import { useMemo } from "react";
import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import get from "lodash/get";

import { isMobile } from "shared/util/EnvironmentHelpers";
import Context from "shared/util/Context";

export const MIGRATION_MODAL_QUERY = gql`
	query MigrationModalQuery($userid: String!) {
		session {
			gatekeeperChecks {
				HAS_PHONE
			}
		}
		auth {
			smsKillSwitches {
				desktop
				mobileWeb
			}
		}
		user(id: $userid) {
			id
			joinDate
		}
	}
`;

const getHasPhone = (data) => get(data, "session.gatekeeperChecks.HAS_PHONE");

const shouldDisableSms = (data) => get(data, `auth.smsKillSwitches.${isMobile ? "mobileWeb" : "desktop"}`);

const getJoinDate = (data) => get(data, "user.joinDate");

export default function useMigrationModalQuery(options = {}) {
	const queryResponse = useQuery(MIGRATION_MODAL_QUERY, { variables: { userid: Context.get("userid") }, ...options });
	const { data } = queryResponse;

	const hasPhone = getHasPhone(data || {});
	const disableSms = shouldDisableSms(data || {}) || Context.has("SMS_KILL_SWITCH");
	const joinDate = getJoinDate(data || {});

	return useMemo(() => ({
		hasPhone,
		joinDate,
		disableSms,
		...queryResponse,
	}), [hasPhone, disableSms, joinDate, queryResponse]);
}



// WEBPACK FOOTER //
// ./src/shared/components/SmsMigrationModal/useMigrationModalQuery.js